export const cordinateToDegree = (cordinate) => {
 let degree = parseInt(cordinate);
 cordinate = (cordinate - degree) * 60;
 let minutes = parseInt(cordinate);
 let second = (cordinate - minutes) * 60;

 return { degree, minutes, second };
};
